import { render, staticRenderFns } from "./EstateManagement.vue?vue&type=template&id=f130aa78&scoped=true"
import script from "./EstateManagement.vue?vue&type=script&lang=js"
export * from "./EstateManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f130aa78",
  null
  
)

export default component.exports